import AppTable from '@/components/AppTable';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import { postImageItemsThemeManagemen } from '@/services/theme-management';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Space } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import PopupItem from './PopupItem';

export default function ItemList({ list, handleSubmitItem, pendingItems, form, isCreate }) {
	const [open, setOpen] = useState(false);
	const [item, setItem] = useState(null);
	const queryClient = useQueryClient();
	const isBreakpoint = useMediaQuery(`(max-width: ${mediaQueryPoints.mdPlus}px)`);

	// tạo preview tạm thời (blob URL) cho các ảnh vừa chọn nhưng chưa submit lên server
	const previewUrls = useMemo(() => {
		const urls = {};
		Object.values(pendingItems || {}).forEach((pendingItem) => {
			const firstImage = pendingItem?.images?.[0];
			if (firstImage instanceof File) {
				urls[pendingItem.itemCode] = URL.createObjectURL(firstImage);
			}
		});
		return urls;
	}, [pendingItems]);

	useEffect(() => {
		return () => {
			Object.values(previewUrls).forEach((url) => URL.revokeObjectURL(url));
		};
	}, [previewUrls]);

	const handleOnEdit = (record) => {
		setItem(record);
		setOpen(true);
	};

	const columns = [
		{
			title: 'No.',
			dataIndex: 'id',
			key: 'id',
			render: (_, __, index) => index + 1,
		},
		{
			title: 'Item Name',
			dataIndex: 'itemName',
			key: 'itemName',
			render: (value) => (value ? value : '-'),
		},
		{
			title: 'Item Description',
			dataIndex: 'description',
			key: 'description',
			render: (value) => (value ? value : '-'),
			width: isBreakpoint ? 300 : 700,
		},
		{
			title: 'Image',
			dataIndex: 'imageUrl',
			key: 'imageUrl',
			// width: isBreakpoint ? 180 : 250,
			render: (_, value) => {
				const previewUrl = previewUrls[value?.itemCode];
				const imagePath = value?.imageUrl || value?.defaultImageUrl;
				const src = previewUrl || (imagePath ? `${process.env.REACT_APP_API_BASEURL}${imagePath}` : '');
				return src ? (
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
						<img
							src={src}
							alt="theme"
							style={{
								width: 70,
								height: "auto",
								objectFit: "cover",
								borderRadius: 4,
							}}
						/>
					</div>
				) : (
					<div
						style={{
							width: "100%",
							height: 48,
							background: "#e9ebef",
							borderRadius: 4,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontSize: 13,
							color: "rgba(139, 147, 161, 1)",
							flexShrink: 0,
						}}
					>
						1080x1920
					</div>
				);
			},
		},
	];

	const mutation = useMutation({
		mutationFn: postImageItemsThemeManagemen,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["themes-default-item"] });
			setOpen(false);
		},
		onError: (error) => {
			console.error("Upload failed:", error);
		},
	});

	return (
		<Space direction="vertical" className="w-full relative">
			<h1 className="font-medium text-lg absolute top-2 left-0">Item List</h1>
			<AppTable
				columns={columns}
				dataSource={list || []}
				hasPagination={false}
				hasRowAction
				onEditAction={handleOnEdit}
			/>
			{open && (
				<PopupItem
					formItem={form}
					open={open}
					isCreate={isCreate}
					setOpen={setOpen}
					item={item}
					loading={mutation.isPending}
					onSubmit={(payload) =>
						handleSubmitItem({ ...item, ...payload }, () => setOpen(false))
					}
				/>
			)}
		</Space>
	)
}
